import React from 'react';
import { ConfigProvider } from '@arco-design/web-react';
// import enUS from '@arco-design/web-react/es/locale/en-US';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';

interface ArcoProviderProps {
  children: React.ReactNode;
}

export const ArcoProvider = ({ children }: ArcoProviderProps) => {
  return (
    <ConfigProvider
      locale={zhCN}
      componentConfig={{
        List: {
          bordered: false,
        },
        Table: {
          border: false,
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
